export const SET_SC_DEPARTMENT_LOADING = 'SET_SC_DEPARTMENT_LOADING'
export const SET_SC_DEPARTMENT = 'SET_SC_DEPARTMENT'
export const ADD_SC_DEPARTMENT = 'ADD_SC_DEPARTMENT'
export const EDIT_SC_DEPARTMENT = 'EDIT_SC_DEPARTMENT'
export const DELETE_SC_DEPARTMENT = 'DELETE_SC_DEPARTMENT'